import {httpGet} from "../../../utils/httpClient";

/**
 * @typedef {Object} DisplayPlaceType
 * @property {string} [displayName]
 * @property {string} [type]
 */

/**
 * Airport item returned by flight autocomplete API
 * @typedef {Object} Airport
 * @property {string} [cityName]
 * @property {string} [countryName]
 * @property {DisplayPlaceType} [displayPlaceType]
 * @property {string} [fullName]
 * @property {string} [iataCode]
 * @property {boolean} [isMetro]
 * @property {int} [placeId]
 * @property {string} [primaryPlaceType]    {'city'|'airport'|'country'}
 * @property {string} [regionName]
 * @property {string} [Iata]
 * @property {string} [Name]
 * @property {string} [city]
 */

/**
 * Fetch airports for the Flight Search autocomplete.
 *
 * @param {string} value
 * @returns {Promise<Airport[]>}
 */
export const getFlightAirportsAutocomplete = (value) => {
  if (!value) {
    return Promise.resolve([]);
  }
  return httpGet(`/api/flight/autocomplete?search=${value}`)
    .then((response) => {
      if (!response.ok) {
        return []; // req failed
      }
      return response.json();
    })
    .then((result) => {
      if (!result) {
        // empty response
        return [];
      }
      const airports = [];
      for (const airport of result) {
        airports.push(airport);
      }
      return airports
        .filter((airport) => airport.iataCode)
        .map(mapAutocompleteResults);
    })
};

const mapAutocompleteResults = (airport) => ({
  Iata: airport.iataCode,
  Name: airport.fullName,
  city: airport.cityName,
  ...airport,
});